const faqs = [
  {
    q: 'Qu&apos;est-ce que Hipobuy Spreadsheet ?',
    a: 'Hipobuy Spreadsheet est un outil nouvelle génération qui combine automatisation avancée, intelligence artificielle et gestion de données dans une interface intuitive, conçue pour les professionnels du marketing, de la finance et des opérations.',
  },
  {
    q: 'Hipobuy Spreadsheet est-il gratuit ?',
    a: 'Hipobuy Spreadsheet propose différents plans adaptés à vos besoins. Consultez le site principal pour découvrir les offres actuelles et choisir celle qui correspond le mieux à votre utilisation.',
  },
  {
    q: 'Quelle différence avec Excel ?',
    a: 'Contrairement à Excel, Hipobuy Spreadsheet intègre nativement l&apos;IA et l&apos;automatisation sans nécessiter de macros complexes. L&apos;interface est plus moderne et la collaboration en temps réel est optimisée pour les équipes.',
  },
  {
    q: 'Est-ce adapté aux entreprises ?',
    a: 'Absolument. Hipobuy Spreadsheet est conçu pour les environnements professionnels exigeants, avec des fonctionnalités de sécurité avancées, une gestion des accès et une scalabilité adaptée aux équipes de toutes tailles.',
  },
  {
    q: 'Peut-on automatiser les données sans coder ?',
    a: 'Oui, c&apos;est l&apos;un des principaux atouts de Hipobuy Spreadsheet. L&apos;automatisation se fait via une interface visuelle intuitive, sans aucune compétence en programmation requise.',
  },
  {
    q: 'Hipobuy Spreadsheet remplace-t-il Google Sheets ?',
    a: 'Hipobuy Spreadsheet offre des capacités bien supérieures à Google Sheets en matière d&apos;automatisation et d&apos;IA. Il peut remplacer Google Sheets pour les utilisateurs qui recherchent des fonctionnalités avancées tout en conservant une simplicité d&apos;utilisation.',
  },
  {
    q: 'Comment commencer avec Hipobuy Spreadsheet ?',
    a: 'Rendez-vous sur le site principal de Hipobuy Spreadsheet pour créer votre compte. L&apos;interface est intuitive et vous serez opérationnel en quelques minutes, avec des tutoriels intégrés pour vous guider.',
  },
  {
    q: 'Les données sont-elles sécurisées ?',
    a: 'La sécurité est une priorité absolue. Hipobuy Spreadsheet utilise un chiffrement de bout en bout, une authentification robuste et est conforme aux normes GDPR pour protéger vos données professionnelles.',
  },
];

export default function FAQSection() {
  return (
    <section className="py-16 md:py-24 bg-accent-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-background-50 text-foreground-800 text-xs font-medium mb-4 whitespace-nowrap">
            FAQ
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight">
            Questions<br />fréquentes
          </h2>
        </div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl p-5 md:p-6">
              <h4 className="font-heading text-base md:text-lg text-foreground-950 mb-3">
                {faq.q}
              </h4>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Essayer Hipobuy Spreadsheet
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        {/* Structured data for FAQ */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.q,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.a,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}